import { useMutation } from '@tanstack/react-query';

import { callDeleteCompetition, type DeleteCompetition } from '@app/client/resources/admin/fantasy/competitions';
import { WISHLIST_SUMMARY_CACHE } from '@app/client/resources/fantasy';

import { useQueryInvalidation } from '../../../reactQuery';
import { useAppSelector } from '../../../redux';

export function useDeleteCompetition() {
    const userId = useAppSelector((s) => s.user.userAccount?.user.id);
    const invalidateWishlists = useQueryInvalidation(WISHLIST_SUMMARY_CACHE);
    const onError = (e) => alert(e);
    return useMutation({
        mutationFn: (slug: DeleteCompetition['slug']) => callDeleteCompetition({ slug, value: { user_id: userId } }),
        onSuccess: invalidateWishlists,
        onError,
    });
}
